import { ISwapQualityIssue } from '@nkr/models/index';
import { Panel } from 'react-bootstrap'

interface IProps {
    data: ISwapQualityIssue
}

const RecipientInfo = (props: IProps) => {
    let { kidneyArrivalDateTimeActual, recipientCenter, recipientAlias, recipientAge, recipientBloodType, recipientSurgeonName } = props.data;

    return (
        <Panel bsStyle='primary'>
            <Panel.Heading>Recipient Info</Panel.Heading>
            <Panel.Body>
                <div className='row'>
                    <div className='col-lg-6'><strong>Surgery Date</strong></div>
                    <div className='col-lg-6'>
                        {kidneyArrivalDateTimeActual != '' ? kidneyArrivalDateTimeActual : '- not specified -'}
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-6'><strong>Transplant Center</strong></div>
                    <div className='col-lg-6'>{recipientCenter}</div>
                </div>

                <div className='row'>
                    <div className='col-lg-6'><strong>Alias</strong></div>
                    <div className='col-lg-6'>{recipientAlias}</div>
                </div>
                <div className='row'>
                    <div className='col-lg-6'><strong>Age</strong></div>
                    <div className='col-lg-6'>{recipientAge}</div>
                </div>
                <div className='row'>
                    <div className='col-lg-6'><strong>Blood Type</strong></div>
                    <div className='col-lg-6'>{recipientBloodType}</div>
                </div>
                <div className='row'>
                    <div className='col-lg-6'><strong>Surgeon</strong></div>
                    <div className='col-lg-6'>
                        {recipientSurgeonName != null ? recipientSurgeonName : '- not specified -'}
                    </div>
                </div>
            </Panel.Body>
        </Panel>
    );
}

export default RecipientInfo;